import React, { useState } from 'react';
import './eyeButton.scss';
import { eyeButtonInterface } from './eyeButtonTypes';
import { ReactComponent as Eye } from '../../assets/eye.svg';
import { ReactComponent as EyeOff } from '../../assets/eye-off.svg';

const EyeButton: React.FC<eyeButtonInterface> = ({ onClick, extraClass }) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const handleClick = () => {
    setIsVisible(!isVisible);
    onClick();
  };

  return (
    <button className="eyeButton" onClick={handleClick} type="button">
      {isVisible ? (
        <Eye className={`icon ${extraClass}`} />
      ) : (
        <EyeOff className="icon" />
      )}
    </button>
  );
};

export default EyeButton;
